export enum SubscriptionType {
    TRIAL = 'trial',
    COMMUNITY = 'community',
    FREE_SKU = 'automationkit',
    FEDRAMP = 'govcloud',
    DIRECT_BUY = 'directbuy',
    TEST_CLOUD_TRIAL = 'test-trial',
    PRO_TRIAL = 'pro-trial',
    STD_TRIAL = 'std-trial',
    BASIC_TRIAL = 'basic-trial',
}
